import options from './help-menu.component';

import ApplicationHelp from './application-help';

import FeedbackForm from './feedback-form';

const Component = {
    selector: 'dtHelpMenu',
    options
};

export default {
    Component,
    ApplicationHelp,
    FeedbackForm
};



// WEBPACK FOOTER //
// ./app/common/help-menu/index.js